export default __webpack_public_path__ + "static/media/plus-advisory.40ddc021.svg";